import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import util from '@/common/util';
import { businessCategoryOrderMap } from '@/components/map/js/markers';

export default {
    emits: [
        'visible',
        'doMapEvent',
        'updateMarkerData',
        'updateMarkerEvent',
    ],
    i18next: {
        ns: 'md-map'
    },
    props: {
        replace: {
            type: Boolean,
            default: false
        },
        businessGroups: {
            type: Array,
            default: () => []
        }
    },
    data: function() {
        return {
            activeType: '',
            businessListMap: {},
            businessGroupActiveIndex: -1,
            itemActiveKey: '',
            transformLink2WordPress: util.transformLink2WordPress
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            "page": store => store.page || {},
            "currencySymbol": store => store.currency?.symbol
        }),
        isMobile() {
            return this.platform.isMobile;
        },
        wordPressSSR({ page }) {
            return page.wordPressSSR;
        },
        businessTabs() {
            return this.businessGroups.map((group, index) => ({
                label: group.label,
                value: index,
                icon: businessCategoryOrderMap[group.label]?.icon || 'icon-show'
            }));
        },
        businessList({ businessGroupActiveIndex }) {
            if (businessGroupActiveIndex !== -1) {
                return this.businessGroups[businessGroupActiveIndex]?.data || [];
            }
            return [];
        }
    },
    watch: {
        businessGroups: {
            handler(value) {
                console.log("🚀 ~ handler ~ value:", value)
                if (value.length && this.businessGroupActiveIndex === -1) {
                    console.log("🚀 ~ handler ~ value:", value)
                    this.businessTabClick(0);
                }
            },
            immediate: true
        }
    },
    created() {
        const self = this;
        const markerEventMap = {
            business: {
                click: function() {
                    self.onMarkerClick(this, 'business');
                }
            }
        };
        this.$emit('updateMarkerEvent', markerEventMap);
    },
    methods: {
        businessTabClick(index) {
            if (index === this.businessGroupActiveIndex) {
                return;
            }
            this.businessGroupActiveIndex = index;
            let data = this.businessGroups[index]?.data || [];
            
            this.$emit('updateMarkerData', {
                business: data.map(item => ({ ...item, icon: this.businessTabs[index].icon }))
            }, true);
        },
        itemEnter(type, item, boundaryFlag = true, autoCenter = false) {
            this.itemActiveKey =
                type + '-' + item.latitude + '-' + item.longitude;
            this.$emit('doMapEvent', function() {
                this.siteMap.setActiveMarker(
                    item.latitude,
                    item.longitude,
                    type
                );
                autoCenter &&
                    this.siteMap.setCenter({
                        lat: item.latitude,
                        lng: item.longitude
                    });
                this.removeBoundary();

                //  Get the request interface boundary
                const typeObj = {
                    city: 'city',
                    neighborhood: 'nbr'
                };
                console.log(type);
                if (typeObj[type]) {
                    this.axiosIns
                        .get(
                            `/api-hj/hj-data/v1/boundary?type=${typeObj[type]}&hjId=${item.hjId}`
                        )
                        .then(boundary => {
                            if (
                                boundary &&
                                boundary.data &&
                                boundary.data.length > 0
                            ) {
                                this.showBoundary(boundary, boundaryFlag);
                            }
                        });
                }
            });
        },
        itemLeave(type) {
            this.itemActiveKey = '';
            this.$emit('doMapEvent', function() {
                this.removeBoundary();
                this.siteMap.clearActiveMarker(type);
            });
        },
        onMarkerClick(marker, type) {
            let selector = '.tab-body .business-list';
            if (type === 'business') {
                this.itemActiveKey =
                    'business-' + marker.lat + '-' + marker.lng;
                if (this.businessGroupActiveIndex !== -1) {
                    this.itemScrollIntoView(selector);
                } 
            }
        },
        itemScrollIntoView(selector) {
            this.$nextTick(() => {
                const $panel = this.$el.querySelector(selector);
                const $item = $panel && $panel.querySelector('.item.active');
                if ($item) {
                    if (!this.isMobile) {
                        window.scrollTo(0, $panel.closest('.md-map').offsetTop + 40)
                    }
                    $panel.scrollTop = $item.offsetTop - $panel.offsetTop;
                }
            });
        }
    }
};
